var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00219727H513V341.99H0V-0.00219727Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00219727H513V85.5015H0V-0.00219727Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.4905H513V170.994H0V85.4905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.994H513V256.498H0V170.994Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171L0 341.996V-0.00817871L256.5 171Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7722 170.994C68.7722 146.081 86.2824 125.267 109.664 120.161C106.001 119.358 102.262 118.952 98.5122 118.951C69.7682 118.951 46.4688 142.251 46.4688 170.994C46.4688 199.737 69.7692 223.038 98.5122 223.038C102.342 223.038 106.07 222.612 109.664 221.827C86.2814 216.721 68.7722 195.908 68.7722 170.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09 126.385L111.857 134.905H120.815L113.568 140.171L116.336 148.69L109.09 143.424L101.842 148.69L104.611 140.171L97.3628 134.905H106.32L109.09 126.385ZM109.09 148.69L111.857 157.209H120.815L113.568 162.475L116.336 170.994L109.09 165.729L101.842 170.994L104.611 162.475L97.3628 157.209H106.32L109.09 148.69ZM109.09 170.994L111.857 179.514H120.815L113.568 184.779L116.336 193.299L109.09 188.033L101.842 193.299L104.611 184.779L97.3628 179.514H106.32L109.09 170.994ZM109.09 193.299L111.857 201.817H120.815L113.568 207.084L116.336 215.603L109.09 210.338L101.842 215.603L104.611 207.084L97.3628 201.817H106.32L109.09 193.299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00622559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/KM.8a95354d37429f4da1109087c87728fd.svg";
export { ForwardRef as ReactComponent };